import React from 'react';

const FluxibleContext = React.createContext();

export default FluxibleContext;



// WEBPACK FOOTER //
// ./src/utils/FluxibleContext.js